import { StoreState } from '@/core/models/store.interface';
import { Candidate } from '@nxtpeople/nxt-styles';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { CandidateService } from './candidate.service';

const service = new CandidateService();

export interface CandidateState {
   candidates: Array<Candidate>;
}

const CandidateStore: Module<CandidateState, StoreState> = {
   namespaced: true,
   state: {
      candidates: [],
   },
   getters: {},
   mutations: {},
   actions: {
      async getCandidates(context, query?: LocationQuery) {
         return await service.getCandidates(query);
      },
      async getCandidate(context, syncId: string, query?: LocationQuery) {
         const response = await service.getCandidate(syncId, query);
      },
   },
};

export default CandidateStore;
